import { MenuPortalTargetOptions } from "@src/components/deprecated/SelectInputField/SelectInputField";
import { t } from "i18next";
import { Text } from "../../../../../components/deprecated/Text/Text";
import { CustomFieldDataOptions } from "../../../Property/Collections/PropertyCustomFieldData";
import { CompanyData } from "../../CompanyData";
import { CustomFieldDataTypeID } from "../CustomFieldDataTypeID";

export interface DataEditorContext {
  propertyID?: string;
  company?: CompanyData;
  menuPortalTarget?: MenuPortalTargetOptions;
}

export class CustomFieldDataTypeHelper<T> {
  id: CustomFieldDataTypeID;
  name: string;

  constructor(id: CustomFieldDataTypeID, name: string) {
    this.id = id;
    this.name = name;
  }

  getDataEditor(
    data: any | undefined,
    options: CustomFieldDataOptions,
    context: DataEditorContext,
    setData: (data: any | undefined) => void
  ): JSX.Element {
    return <Text size="sm">{t("main.notYetSupported")}</Text>;
  }

  // TODO: Later we should remake the CustomFieldDataTypeHelper to use hooks
  getStringRepresentation(data: any | undefined, options: CustomFieldDataOptions, context: DataEditorContext): string | Promise<string> {
    return data === undefined || data === null ? "" : "" + data;
  }

  convertData(data: any): T | undefined {
    return data;
  }

  // TODO: Later we should remake the CustomFieldDataTypeHelper to use hooks
  loadData(context: DataEditorContext, onFinish?: () => void) {}
}
